import React, { useEffect, useRef, useState } from 'react';
import PhishingIcon from '../../../Layout/Components/PhishingIcon';

export default function CopyableDeliveryValue({ label, value, t }) {
  const [status, setStatus] = useState('');
  const sequence = useRef(0), timer = useRef(null);
  useEffect(() => {
    setStatus('');
    return () => { ++sequence.current; clearTimeout(timer.current); };
  }, [value]);
  async function copy() {
    const request = ++sequence.current;
    clearTimeout(timer.current); setStatus('copying');
    try {
      if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
      await navigator.clipboard.writeText(value);
      if (request !== sequence.current) return;
      setStatus('copied');
      timer.current = setTimeout(() => setStatus(''), 2000);
    } catch (_) { if (request === sequence.current) setStatus('error'); }
  }
  const copyLabel = t('authenticated_domains.copy_field', { field: label });
  return <div>
    <small>{label}</small>
    <div className="authenticated-domains__record-value"><code>{value}</code>
      <button type="button" className={`authenticated-domains__copy${status === 'copied' ? ' authenticated-domains__copy--done' : ''}`}
        aria-label={copyLabel} title={status === 'copied' ? t('authenticated_domains.copied') : copyLabel}
        disabled={!value || status === 'copying'} onClick={copy}>
        <PhishingIcon name={status === 'copied' ? 'check' : 'copy'} />
      </button>
    </div>
    <span className={`authenticated-domains__copy-feedback${status === 'error' ? ' text-danger' : ''}`} role="status">
      {status === 'copied' ? t('authenticated_domains.copied') : status === 'error' ? t('authenticated_domains.copy_failed') : ''}
    </span>
  </div>;
}
